// extracted by mini-css-extract-plugin
export default {"base-container":"NavigationLayout_base-container__VG8dh"};